import ColorSpace from "../ColorSpace.js";
import OKLCH from "./oklch.js";
import maxChroma from "../maxChroma.js";
import { isNone } from "../util.js";

export default new ColorSpace({
	id: "oklch-p3",
	name: "OKLCh P3",
	coords: {
		l: {
			refRange: [0, 1],
			name: "Lightness",
		},
		c: {
			range: [0, 1],
			name: "Chroma",
		},
		h: {
			refRange: [0, 360],
			type: "angle",
			name: "Hue",
		},
	},
	white: "D65",

	base: OKLCH,

	toBase ([l, c, h]) {
		if (![l, c, h].some(isNone)) {
			c *= maxChroma(l, h, { space: OKLCH, gamut: "p3" });
		}

		return [l, c, h];
	},

	fromBase ([l, c, h]) {
		if (![l, c, h].some(isNone)) {
			let cMax = maxChroma(l, h, { space: OKLCH, gamut: "p3" });
			c = cMax ? c / cMax : 0;
		}

		return [l, c, h];
	},

	formats: {
		color: {
			id: "--oklch-p3",
			coords: ["<percentage> | <number>", "<number> | <percentage>", "<number> | <angle>"],
		},
	},
});
